<template>
  <el-dialog
    v-drag
    :visible.sync="dialogVisible"
    width="1000px"
    :title="editData.id ? '修改清关咨询信息' : '新增清关咨询信息'"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    append-to-body
    top="5vh"
  >
    <el-form
      ref="form"
      class="form"
      :model="form"
      :rules="rules"
      label-position="top"
    >
      <el-row class="row" :gutter="20">
        <el-col :span="6">
          <el-form-item label="中文品名" prop="nameCH">
            <el-input v-model="form.nameCH"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="英文品名" prop="nameEN">
            <el-input v-model="form.nameEN"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="用途" prop="usedFor">
            <el-input v-model="form.usedFor"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="材质" prop="material">
            <el-input v-model="form.material"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row" :gutter="20">
        <el-col :span="6">
          <el-form-item label="原产国" prop="originCountry">
            <el-select v-model="form.originCountry">
              <el-option
                v-for="item in addressDropOption"
                :key="item.code"
                :label="item.label"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否可清关" prop="isClearence">
            <el-switch
              v-model="form.isClearence"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="客户" prop="companyId">
            <el-select v-model="form.companyId">
              <el-option
                v-for="(item, $index) in companyDrapdown"
                :key="$index"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="美国税号" prop="hsCode">
            <el-input v-model="form.hsCode">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row" :gutter="20">
        <el-col :span="6">
          <el-form-item label="基础税率" prop="baseRate">
            <el-input v-model="form.baseRate"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="加征税率1" prop="addRate1">
            <el-input-number
              v-model="form.addRate1"
              controls-position="right"
              style="width: 100%"
              :min="0"
              :precision="2"
              :step="1"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="加征税率2" prop="addRate2">
            <el-input-number
              v-model="form.addRate2"
              controls-position="right"
              style="width: 100%"
              :min="0"
              :precision="2"
              :step="1"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="加征税率3" prop="addRate3">
            <el-input-number
              v-model="form.addRate3"
              controls-position="right"
              style="width: 100%"
              :min="0"
              :precision="2"
              :step="1"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row" :gutter="20">
        <el-col :span="12">
          <el-form-item label="清关条件" prop="conditions">
            <el-input v-model="form.conditions"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注" prop="remark">
            <el-input v-model="form.remark"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row" :gutter="20">
        <el-col :span="24">
          <el-form-item prop="systemFileId">
            <span slot="label">
              上传文件<span style="color: #FE453D;">(仅支持图片文件)</span>
            </span>
            <div class="upload">
              <el-upload
                class="upload-demo"
                action="/api/SystemFile/uploadFile?source=17"
                :data="{source: 17}"
                :headers="headers"
                :before-upload="beforeUpload"
                :on-success="onSuccess"
                :before-remove="handleRemove"
                :file-list="fileList"
                list-type="picture">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div class="ok flex_c_c" @click="ok('form')">
        确定{{ editData.id ? "修改" : "新增" }}
      </div>
    </span>
    <TaxDialog
      :dialogVisible="dialogVisible2"
      @ok="ok2"
      @cancel="cancel2"
    ></TaxDialog>
  </el-dialog>
</template>
<script>
import {
  modifyClearanceConsultation,
  addClearanceConsultation,
  fileList
 } from '@/api/system'
import { mapGetters } from 'vuex'
import TaxDialog from '@/components/dialog/TaxDialog'
export default {
  components: { TaxDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0 // 0 新增 1修改
    },
    editData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        hsCode: '',
        nameCH: '',
        nameEN: '',
        material: '',
        remark: '',
        originCountry: '',
        isClearence: true,
        usedForFor: '',
        conditions: '',
        baseRate: 0,
        addRate1: 0,
        addRate2: 0,
        addRate3: 0,
        fileId: []
      },
      rules: {
        nameEN: [
          { required: true, message: '请输入英文品名', trigger: 'blur' }
        ],
        nameCH: [
          { required: true, message: '请输入中文品名', trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        isClearence: [
          { required: true, message: '请选择是否清关', trigger: 'change' }
        ],
        material: [{ required: true, message: '请输入材质', trigger: 'blur' }],
        usedFor: [{ required: true, message: '请输入用途', trigger: 'blur' }]
      },
      dialogVisible2: false,
      fileList: [],
      headers: { 'ESCLEARANCE': btoa(`BC5BC301345F4D57CC1A8EF1F74579A7&${Date.now()}`) }
    }
  },
  computed: {
    ...mapGetters(['companyDrapdown', 'addressDropOption'])
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.fileList = []
        if (this.editData.id) {
          this.form = {
            ...this.editData
          }
          if (this.editData.fileQty > 0) {
            this.getFileList()
          }
        } else {
          this.form = {
            hsCode: '',
            nameCH: '',
            nameEN: '',
            material: '',
            remark: '',
            originCountry: '',
            isClearence: true,
            usedForFor: '',
            conditions: '',
            baseRate: 0,
            addRate1: 0,
            addRate2: 0,
            addRate3: 0,
            fileId: []
          }
        }
      }
    }
  },
  mounted() {
    // if (!this.addressDropOption || this.addressDropOption.length === 0) {
    //   this.$store.dispatch('getAddress')
    // }
    if (!this.companyDrapdown.length) {
      this.$store.dispatch('getCompanyDrapdown')
    }
  },
  methods: {
    cancel() {
      this.$refs['form']?.resetFields()
      this.$emit('cancel')
    },
    ok(formName) {
        console.log('this.fileList', this.fileList)
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          const params = {
            ...this.form
          }
          try {
            let res
            if (this.editData.id) {
                res = await modifyClearanceConsultation(params)
            } else {
                res = await addClearanceConsultation(params)
            }
            if (res.success) {
              this.$message.success('操作成功')
              this.$refs[formName]?.resetFields()
              this.$emit('ok')
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.log(error)
          }
        }
      })
    },
    search() {
      this.dialogVisible2 = true
    },
    ok2(row) {
      this.form = {
        ...this.form,
        hsCode: row.hsCode,
        baseRate: row.baseRate,
        addRate1: row.addRate,
        addRate2: row.addRate1
      }
      this.cancel2()
    },
    cancel2() {
      this.dialogVisible2 = false
    },
    onSuccess(res) {
      if (!res.success) {
        this.$message.error(res.errorMessage)
      } else {
        this.form.fileId.push(res.data.fileId)
      }
    },
    onError(error) {
      this.$message.error('上传失败')
      console.error(error)
    },
    beforeUpload(file) {
      const suffix = file.name.slice(
        file.name.lastIndexOf('.') + 1,
        file.name.length
      ).toLowerCase()
      if (!(suffix === 'png' || suffix === 'jpg' || suffix === 'jpeg')) {
        this.$message.error('仅支持上传图片格式文件')
        return false
      }
    },
    handleRemove(file, fileList) {
        // console.log('file', file, fileList)
        const index = fileList.findIndex(item => item.uid === file.uid)
        this.form.fileId.splice(index, 1)
    },
    async getFileList() {
        try {
            const res = await fileList({
                id: this.editData.id
            })
            if (res.success) {
                this.fileList = res.data.map(item => {
                    return {
                        name: item.fileName,
                        url: `/api/SystemFile/preview?guid=${item.guid}`
                    }
                })
                this.form.fileId = res.data.map(item => item.fileId)
            }
        } catch (error) {
            console.log(error)
        }
    }
  }
}
</script>
<style lang="less" scoped>
:deep(.el-dialog__body) {
  padding: 30px 10px;
}
.form {
  margin: 0 54px;
  .upload {
    width: 100%;
    padding: 20px 20px;
    box-sizing: border-box;
    background: #f7f7f7;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    margin-top: 5px;
    &:deep(.el-upload-list) {
        display: flex;
        flex-wrap: wrap
    }
    &:deep(.el-upload-list--picture .el-upload-list__item) {
        width: 50%;
    }
  }
}
.row {
  display: flex;
  justify-content: space-between;
  &:deep(.el-form-item) {
    margin-bottom: 16px;
    .el-form-item__label {
      line-height: 20px;
    }
  }
  .icon {
    font-size: 20px;
    margin-left: 10px;
    cursor: pointer;
    color: rgb(18, 88, 188);
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
